import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredMovies = activeCategory === 'all'
    ? movies.slice(0, 8)
    : movies.filter((m) => m.category === activeCategory).slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型发现你喜欢的影视内容</p>
        </div>

        <div className="flex items-center justify-center gap-2 flex-wrap mb-8">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-primary-500 text-white'
                  : 'bg-white text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4" data-product-shop>
          {filteredMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to={`/category/${activeCategory === 'all' ? 'movie' : activeCategory}`}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-foreground-700 text-sm font-medium rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}